import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './Section.module.css';
export const Section = ({ content, decoration, decorationMandatory, className, }) => {
    const classNames = className
        ? `${classes.section} ${className}`
        : classes.section;
    const decorationOutput = decoration ? (_jsx("article", Object.assign({ className: decorationMandatory
            ? `${classes.decoration} ${classes.alwaysShow}`
            : classes.decoration }, { children: decoration }))) : null;
    return (_jsxs("section", Object.assign({ className: classNames }, { children: [_jsx("article", Object.assign({ className: classes.content }, { children: content })), decorationOutput] })));
};
